import {AppConfig} from "./AppConfig";
import {StorageHelper} from "./StorageHelper";

export class HttpHelper {

    static get(url, queryParams = {}) {
        const params = HttpHelper.obtenerQueryActualDeVue();
        if (params["clave-proyecto"]) queryParams["clave"] = params["clave-proyecto"];

        let urlWithParams = new URL(this.generateUrl(url));
        urlWithParams.search = new URLSearchParams(queryParams);

        return fetch(urlWithParams, {
            method: "GET",
            headers: this.makeHeaders(),
            credentials: "same-origin"
        }).then(this.handleErrors);
    }

    static post(url, params = {}) {
        return fetch(this.generateUrl(url), {
            method: "POST",
            headers: this.makeHeaders(),
            credentials: "same-origin",
            body: JSON.stringify(params)
        }).then(this.handleErrors);
    }

    static handleErrors(response) {
        const contentType = response.headers.get("content-type");
        const esJson = contentType && contentType.includes("application/json");

        if (!response.ok) {
            if (response.status === 401) StorageHelper.delete(AppConfig.TOKEN_CLAVE);

            if (esJson) return response.json().then(json => {
                return Promise.reject(json);
            });
            return Promise.reject(response.text());
        }

        if (response.status === 204) return null;

        if (esJson) return response.json();
        return response.text();
    }

    static makeHeaders() {
        let headersValues = {
            'Accept': 'application/json, */*',
            'Content-Type': 'application/json'
        };
        if (window.location.hostname.includes('localhost')) {
            headersValues = {
                'Accept': 'application/json, */*',
                // 'Content-Type': 'application/json'
                //MANTENER LINEAS PARA LOCAL
                'Content-Type': 'application/json',
                'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
                'Access-Control-Allow-Headers': 'Origin, Accept, Content-Type, Authorization, Access-Control-Allow-Origin',
                'Access-Control-Allow-Origin': '*',
            }
        }

        let token = StorageHelper.get(AppConfig.TOKEN_CLAVE);
        if (token != null) {
            headersValues["Authorization"] = `Bearer ${token}`;
        }

        let headers = new Headers();

        Object.keys(headersValues).forEach(key => {
            headers.append(key, headersValues[key]);
        });

        return headers;
    }

    static generateUrlNoApi(url) {
        let bar = url.length > 0 && url.substr(0) !== "/" ? "/" : "";

        return AppConfig.URL_BASE + bar + url;
    }

    static generateUrl(url) {
        let bar = url.length > 0 && url.substr(0) !== "/" ? "/" : "";

        return AppConfig.URL_BASE_API + bar + url;
    }

    static stringQueryFromObject(object) {
        return Object.keys(object).map(key => `${key}=${encodeURIComponent(object[key])}`).join('&');
    }

    static obtenerQueryActualDeVue() {
        let uri = window.location.href.split('?');
        if (uri.length !== 2) return {};

        let vars = uri[1].split('&');
        let getVars = {};
        let tmp = '';
        vars.forEach(function (v) {
            tmp = v.split('=');
            if (tmp.length === 2)
                getVars[tmp[0]] = tmp[1];
        });

        return getVars;
    }
}